import "highcharts/modules/drilldown";

import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useEffect, useRef, useState } from "react";

export const FinincalBookingData = ({ data }: any) => {
  const [options, setOptions] = useState<Highcharts.Options>({});
  const [shouldScroll, setShouldScroll] = useState(false);
  const chartRef = useRef<any>(null);

  useEffect(() => {
    if (!data) return;

    const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
    const tooManyItems = data.items.length > 6;
    if (isMobile && tooManyItems) {
      setShouldScroll(true);
    }

    const mainSeriesData = data.items.map((month: any) => ({
      name: month.Name,
      y: month.Value !== null && month.Value !== undefined ? month.Value : 0,
      drilldown: month.Value !== null && month.Value > 0 ? month.Name : null,
    }));

    const drilldownMonth = data.items.find(
      (item: any) => item.Value !== null && item.Value > 0
    )?.Name;

    const drilldownData = drilldownMonth
      ? [
          {
            id: drilldownMonth,
            name: `${drilldownMonth} Details`,
            data: data.drilldown.map((day: any) => [
              day.Name,
              day.Value !== null && day.Value !== undefined ? day.Value : 0,
            ]),
            type: "column",
          },
        ]
      : [];

    const chartOptions: Highcharts.Options = {
      chart: {
        type: "column",
        ...(shouldScroll && {
          scrollablePlotArea: {
            minWidth: data.items.length * 80, // Adjust width based on number of bars
            scrollPositionX: 0,
          },
        }),
        events: {
          render(this: Highcharts.Chart) {
            const title = this.title?.element;

            if (title) {
              const scrollableBox = (this as any).scrollablePlotBox;
              const scrollX = (this.plotLeft || 0) - (scrollableBox?.x || 0);
              title.setAttribute("transform", `translate(${scrollX}, 0)`);
            }
          },
        },
      },
      title: {
        text: "Booking",
        align: "center",
        style: {
          fontSize: "13px",
        },
      },
      xAxis: {
        type: "category",
        labels: {
          step: 1,
          style: {
            fontSize: "11px",
          },
        },
      },
      yAxis: {
        title: {
          text: "Total Value",
          style: {
            fontSize: "14px",
          },
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: false,
            format: "{point.y:.2f}",
          },
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:14px">{series.name}</span><br/>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b><br/>',
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "Months",
          colorByPoint: true,
          data: mainSeriesData,
          type: "column",
        },
      ],
      ...(data?.drilldown?.length > 1 && {
        drilldown: {
          series: drilldownData as Highcharts.SeriesOptionsType[],
        },
      }),
    };

    setOptions(chartOptions);
  }, [data]);

  return (
    <div style={{ overflowX: shouldScroll ? "auto" : "visible" }}>
      <div
        style={{
          minWidth: shouldScroll ? `${data.items.length * 80}px` : "100%",
        }}
      >
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          ref={chartRef}
        />
      </div>
    </div>
  );
};
